export const DE = 'de'
export const EN = 'en'
export const NL = 'nl'
export const FR = 'fr'

// Sprachen, in denen das Formular vollständig übersetzt ist. Entspricht den
// Sprachen, die die Talent-App annimmt (aivy-universal-app src/utils/languages.js)
export const SUPPORTED_LANGUAGES = [DE, EN, NL, FR]

// Eine nicht unterstützte Sprache landet auf Englisch statt auf rohen i18n-Keys
export const FALLBACK_LANGUAGE = EN

// 'fr-BE' oder 'NL' auf den reinen Sprachcode bringen
const normalizeLanguage = (language) => {
  if (typeof language !== 'string') return null

  return language.trim().toLowerCase().split('-').shift()
}

export const isLanguageSupported = (language) => {
  return SUPPORTED_LANGUAGES.includes(normalizeLanguage(language))
}

export const getSupportedLanguage = (language) => {
  const normalized = normalizeLanguage(language)

  return SUPPORTED_LANGUAGES.includes(normalized)
    ? normalized
    : FALLBACK_LANGUAGE
}
